{
  "GenericAdminFilterLanguage_CME_LABEL": "CME",
  "GenericAdminFilterLanguage_TELSYS_LABEL": "Telefonieserver",
  "GenericAdminFilterLanguage_PARTITION_LABEL": "Partitie",
  "GenericAdminFilterLanguage_CRM_TYPE_LABEL": "CRM-type",
  "GenericAdminFilterLanguage_INCLUDE_CHILD_CMES_LABEL": "Inclusief onderliggende CME-items",
  "GenericAdminFilterLanguage_SEARCH_LABEL": "Zoekopdracht",
  "NAME": "GenericAdminFilterLanguage"
}